/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ day: NonNullable<unknown> }} Today_Day_FreeInputs */

const en_us2_today_day_free = /** @type {(inputs: Today_Day_FreeInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.day} · Free day`)
};

const pt_br2_today_day_free = /** @type {(inputs: Today_Day_FreeInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.day} · Dia livre`)
};

const es_419_today_day_free = /** @type {(inputs: Today_Day_FreeInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.day} · Día libre`)
};

const pt_pt2_today_day_free = /** @type {(inputs: Today_Day_FreeInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.day} · Dia livre`)
};

const fr_fr2_today_day_free = /** @type {(inputs: Today_Day_FreeInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.day} · Jour libre`)
};

const de_de2_today_day_free = /** @type {(inputs: Today_Day_FreeInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.day} · Freier Tag`)
};

const it_it2_today_day_free = /** @type {(inputs: Today_Day_FreeInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.day} · Giorno libero`)
};

/**
* | output |
* | --- |
* | "{day} · Free day" |
*
* @param {Today_Day_FreeInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const today_day_free = /** @type {((inputs: Today_Day_FreeInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Today_Day_FreeInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_today_day_free(inputs)
	if (locale === "es-419") return es_419_today_day_free(inputs)
	if (locale === "pt-PT") return pt_pt2_today_day_free(inputs)
	if (locale === "fr-FR") return fr_fr2_today_day_free(inputs)
	if (locale === "de-DE") return de_de2_today_day_free(inputs)
	if (locale === "it-IT") return it_it2_today_day_free(inputs)
	return en_us2_today_day_free(inputs)
});
export { today_day_free as "today.day_free" }